// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from '../../components/CRUD/ViewEntity';

const ViewOrganisationBanks = () => {
  return (
    <ViewEntity
      pageTitle="OrganisationBankInfo"
      fetchApiUrl="/api/v1/web_portal/settlements/organisation-banks/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      fields={[
        {
          name: 'account_name',
          labelKey: 'AccountName',
          type: 'text',
        },
        {
          name: 'account_number',
          labelKey: 'AccountNumber',
          type: 'text',
        },
        {
          name: 'iban',
          labelKey: 'IBAN',
          type: 'text',
        },
        {
          name: 'branch_name',
          labelKey: 'BranchName',
          type: 'text',
        },
        {
          name: 'branch_address',
          labelKey: 'BranchAddress',
          type: 'text',
        },
        {
          name: 'beneficiary_email',
          labelKey: 'BeneficiaryEmail',
          type: 'text',
        },
        {
          name: 'beneficiary_mobile',
          labelKey: 'BeneficiaryMobile',
          type: 'text',
        },
        {
          name: 'bank_name',
          labelKey: 'BankName',
          type: 'custom',
          render: (data, additionalData, intl) => {
            const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
            return currentLanguageCode === 'en-us' 
              ? data.bank_name_en 
              : data.bank_name_ar;
          },
        },
        {
          name: 'organisation_name',
          labelKey: 'Organisation',
          type: 'custom',
          render: (data, additionalData, intl) => {
            const orgData = additionalData?.organisationDetails;
            if (!orgData) return '-';
            const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
            return currentLanguageCode === 'en-us' 
              ? orgData.en_name 
              : orgData.ar_name;
          },
        },
        {
          name: 'financial_account_name',
          labelKey: 'FinancialAccount',
          type: 'custom',
          render: (data, additionalData, intl) => {
            const financialAccountData = additionalData?.financialAccountDetails;
            return financialAccountData?.name || '-';
          },
        },
        {
          name: 'created_at',
          labelKey: 'CreatedAt',
          type: 'date',
        },
        {
          name: 'updated_at',
          labelKey: 'UpdatedAt',
          type: 'date',
        },
      ]}
      additionalApis={[
        {
          name: 'organisationDetails',
          url: (mainData) => `/api/v1/organisations/${mainData.organisation_id}`,
          method: 'GET',
          dataPath: 'data.data',
        },
        {
          name: 'financialAccountDetails',
          url: (mainData) => `/api/v1/web_portal/settlements/financial-accounts/${mainData.financial_account_id}`,
          method: 'GET',
          dataPath: 'data.data',
        },
      ]}
      editUrl="/settlements/OrganisationBanks/:id/edit"
      deleteApiUrl="/api/v1/web_portal/settlements/organisation-banks/:id"
      deleteApiMethod="DELETE"
      backUrl="/settlements/OrganisationBanks/"
      backButtonLabel="BackToOrganisationBanks"
      buildTitle={(data, additionalData, intl) => {
        return data.account_name;
      }}
      buildDeleteConfirmMessage={(data, additionalData, currentLanguageCode, intl) => {
        const bankName = currentLanguageCode === 'en-us' ? data.bank_name_en : data.bank_name_ar;
        return currentLanguageCode === 'en-us'
          ? `Are You Sure You Want To Delete ${data.account_name} - ${bankName}?`
          : `هل أنت متأكد انك تريد حذف ${data.account_name} - ${bankName}؟`;
      }}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="OrganisationBanks"
    />
  );
};

export default ViewOrganisationBanks;
